module.exports = __webpack_public_path__ + "static/media/Pin_Job_Motorcycle.62383d51.svg";